import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { CommonService } from '../../../services/student-services/common/common.service';
@Component({
	selector: 'app-go-back',
	templateUrl: './go-back.component.html',
	styleUrls: [ './go-back.component.scss' ]
})
export class GoBackComponent implements OnInit {
	@Output() goBack = new EventEmitter<string>();
	@Output() activePhaseAndTaskEvent = new EventEmitter<any>();

	@Input() taskInput;
	@Input() studentData;
	@Input() sidebarInput;

	constructor(private readonly location: Location, private readonly common: CommonService) {}

	ngOnInit() {}

	goToCurrentStep(path: string) {
		const currentPhaseTask = this.common.getCurrentPhaseAndTask(this.sidebarInput.phases, this.studentData);

		this.location.replaceState(`/${path}`);
		this.goBack.emit(path);
		this.activePhaseAndTaskEvent.emit(currentPhaseTask);
	}

	/**
* @description Will calculate the next pending phase and task for redirecting the user.
* @param phases (array) Will hold all phases wth task property
* @param currentTask (Object) will hold the current active task information.
* @param studentData (Object) will hold student doc data
*/
	calculateNextPahseAndTask(phases, currentTask, studentData) {
		let nextPhase; // will hold next phase information
		let nextTask; // Will hold next task information

		// loop through the all phases and check for
		// pending task and then get the pahse information as well.

		let phaseIndex = 0;
		while (phaseIndex < phases.length) {
			// each phase
			for (let taskIndex = 0; taskIndex < phases[phaseIndex].tasks.length; taskIndex++) {
				// each task
				const phaseObject = { ...phases[phaseIndex] };
				const taskObject = { ...phases[phaseIndex].tasks[taskIndex] };
				// get lock status info
				const lockedStatus = this.checkTaskStatus(taskObject, studentData);
				if (!lockedStatus) {
					// If not locked then this is the pending task.
					nextPhase = phaseObject;
					nextTask = taskObject;
					break; // braek for..loop
				} // End of if
			} // End of for
			if (nextPhase && nextTask) {
				break; // braek while loop
			}
			phaseIndex++;
		} // End of while loop
		if (!nextPhase && !nextTask) {
			nextPhase = phases[0];
			nextTask = phases[0].tasks[0];
		}
		return {
			nextPhase,
			nextTask
		};
	}

	/**
   * @description This function will check that the task status is locked or not
   * @param task (Object) Task Object
   * @param studentData (Object) Student doc data
   */
	checkTaskStatus(task, studentData) {
		if (studentData.user_tasks) {
			const lockedTaskInfo = studentData.user_tasks.find((lockedTask) => {
				if (lockedTask.task_id === task._id) {
					return lockedTask;
				}
			});
			if (lockedTaskInfo) {
				return true;
			}
			return false;
		} else {
			return false;
		}
	}
}
